import React from "react";
import classnames from "classnames";
import "./styles.scss";

interface LoadingProps {
  small?: boolean;
  full?: boolean;
  dark?: boolean;
  message?: any;
}

const Loading = (props: LoadingProps) => {
  const loadingClassNames = classnames("loading", {
    "loading--full": props.full,
  });

  const spinnerClassNames = classnames("loading__ring", {
    "loading__ring--small": props.small,
    "loading__ring--dark": props.dark,
  });

  return (
    <div
      data-testid="loading"
      className={loadingClassNames}>
      <div>
        <div
          data-testid="loading-spinner"
          className={spinnerClassNames}
        />
        {props.message && (
          <div
            data-testid="loading-message"
            className="loading__message">
            {props.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;
